import { render, staticRenderFns } from "./talentConcept.vue?vue&type=template&id=72a3368b&scoped=true&"
import script from "./talentConcept.vue?vue&type=script&lang=js&"
export * from "./talentConcept.vue?vue&type=script&lang=js&"
import style0 from "./talentConcept.vue?vue&type=style&index=0&id=72a3368b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3368b",
  null
  
)

export default component.exports